import React from "react";
import { Calendar, Download, DoorOpen, MapPin, Printer } from "lucide-react";
import PrixBillet from "./PrixBillet";

const LIBELLES = { plein: "Plein tarif", enfant: "Enfant 3-12 ans", bebe: "Enfant 0-2 ans (sur les genoux, sans place)" };

/* Le billet d'une commande payée : l'affiche, la représentation, le QR code à présenter à
   l'entrée (un seul pour toute la commande). Sert à la page « merci » et à /billet/…. */
export default function CarteBillet({ billet }) {
  const majuscule = (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1) : "");
  return (
    <div className="card-flat !p-0 overflow-hidden max-w-xl mx-auto text-left" data-testid="carte-billet">
      <div className="grid sm:grid-cols-[180px_1fr]">
        {billet.affiche && (
          <img src={billet.affiche} alt={`Affiche · ${billet.titre}`} className="w-full h-56 sm:h-full object-cover" />
        )}
        <div className="p-6 space-y-3">
          <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--primary)]">Billet · {billet.numero}</div>
          <h2 className="font-display text-3xl leading-tight">{billet.titre}</h2>
          <div className="text-sm space-y-1.5">
            <div className="flex items-start gap-2"><Calendar size={15} className="mt-0.5 shrink-0" /> {majuscule(billet.quand)}</div>
            <div className="flex items-start gap-2"><DoorOpen size={15} className="mt-0.5 shrink-0" /> Ouverture des portes à {billet.portes}</div>
            <div className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 shrink-0" />
              <span>{billet.salle}, {billet.adresse}{billet.itineraire && <> · <a href={billet.itineraire} target="_blank" rel="noopener noreferrer" className="underline">itinéraire</a></>}</span></div>
          </div>
          {billet.prix?.length ? <PrixBillet billet={billet} /> : (
            <ul className="text-sm">
              {["plein", "enfant", "bebe"].filter((k) => billet[k] > 0).map((k) => (
                <li key={k}><strong>{billet[k]} ×</strong> {LIBELLES[k]}
                  {k === "plein" && billet.offerts > 0 && <span className="text-[var(--muted)]"> (dont {billet.offerts} offert{billet.offerts > 1 ? "s" : ""} · bénévole)</span>}</li>
              ))}
            </ul>
          )}
          {(billet.prenom || billet.nom) && <div className="text-sm text-[var(--muted)]">Au nom de {billet.prenom} {billet.nom}{billet.commande_le ? ` · commandé le ${billet.commande_le}` : ""}</div>}
        </div>
      </div>
      <div className="border-t p-6 flex flex-col items-center gap-3" style={{ borderColor: "var(--border)" }}>
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/billetterie/billets/${billet.jeton}/qr.svg`} alt="QR code du billet"
          className="w-52 h-52" data-testid="billet-qr" />
        <p className="text-sm text-center">Présente ce QR code à l'entrée, sur ton téléphone ou imprimé.</p>
        {/* Jen, 31.10.2026 : « je dois aussi pouvoir le sauver, pas seulement imprimer ». */}
        <div className="flex flex-wrap justify-center gap-2 print:hidden">
          <a href={`${process.env.REACT_APP_BACKEND_URL}/api/billetterie/billets/${billet.jeton}/pdf`} download={`billet-${billet.numero}.pdf`}
            className="btn-primary text-sm" data-testid="billet-pdf"><Download size={15} /> Enregistrer le billet (PDF)</a>
          <button type="button" onClick={() => window.print()} className="btn-ghost text-sm" data-testid="billet-imprimer"><Printer size={15} /> Imprimer</button>
        </div>
        <p className="text-xs text-[var(--muted)] text-center max-w-sm">{billet.conditions}</p>
      </div>
    </div>
  );
}
